import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { EMPTY } from "rxjs";
import { tap } from "rxjs/operators";
import { EeseRequirementApiService } from "src/app/services/api/eese-requirement-api.service";
import { EeseRequirementsStateModel } from "./eeseRequirements.state.model";
import { EeseRequirementsActions } from "./eeseRequirements.actions";

@State<EeseRequirementsStateModel>({
    name: 'eeseRequirements',
    defaults: {
        eeseRequirements: []
    },
})
@Injectable()
export class EeseRequirementsState {
    constructor(private eeseRequirementApiService: EeseRequirementApiService) {}

    @Action(EeseRequirementsActions.SetAllEeseRequirements)
    SetAllEeseRequirements(ctx: StateContext<EeseRequirementsStateModel>) {
        const state = ctx.getState();
        if (state.eeseRequirements && state.eeseRequirements.length > 0)
            return EMPTY;

        return this.eeseRequirementApiService.getAll().pipe(
            tap(eeseRequirements => {
                if (eeseRequirements) {
                    ctx.patchState({ eeseRequirements: [...eeseRequirements].sort((a, b) => a.name?.localeCompare(b.name)) });
                }
            })
        );
    }

    @Selector()
    static getAllEeseRequirements(state: EeseRequirementsStateModel) {
        return state.eeseRequirements;
    }
}
